import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from "react-localize-redux";
import { translateDate } from '../../utils/utils';
import { resetProviderAction } from '../../actions/providersActions';

export default function Company({ company , contacts , dispatch , ...props }) {


const mainUser = contacts?.find(u =>  u._id === company.mainUser);
  function alertResetCompany() {
    var answer = window.confirm("Souhaitez-vous réinitialiser le fournisseur ?")
      if (answer) {
        resetProviderAction(dispatch , company._id );
      }
  }
  
  function renderProviderCompany() {
    return (
      <div className="card info">

        <div className="information-container">
          <p className="p-col-3">
            <span className="bold"><Translate id="company.social"/></span><br/>
            {company.name}
          </p>
          <p className="p-col-3">
            <span className="bold"><Translate id="company.code"/></span><br/>
            {company.code}
          </p>
          <p className="p-col-3">
            <span className="bold"><Translate id="company.iddigit"/></span><br/>
            {company.iddigit}
          </p>
          {company.wholesaler?.name &&
            <p className="p-col-3">
              <span className="bold"><Translate id="company.wholesaler"/></span><br/>
              {company.wholesaler?.name}
            </p>
          }
          {mainUser?.profile &&
            <p className="p-col-3">
              <span className="bold"><Translate id="company.mainUser"/></span><br/>
              {mainUser.profile.firstName} {mainUser.profile.lastName}
            </p>
          }
          <p className="p-col-3">
            <span className="bold"><Translate id="company.numberOfOffers"/></span><br/>
            {company.numberOfOffers}
          </p>
        </div>

        <div className="col-1">
          <span className="bold"><Translate id="company.domains"/></span><br/>
          <div className="information-container">
            <div className="col-1">
              {company?.domains?.map((item ,i ) => <div key={i} className="list-item selected">{item}</div>)}
            </div>
          </div>
        </div>

        <div className="col-1">
          <span className="bold"><Translate id="company.products"/></span><br/>
          <div className="information-container">
            <div className="col-1">
              {company?.products?.map((item ,i ) => <div key={i} className="list-item selected">{item}</div>)}
            </div>
          </div>
        </div>
        
        <div className="col-1">
          <span className="bold"><Translate id="company.insurance"/></span><br/>
          <div className="information-container">
            <p className="p-col-3 contact border">
              {company?.insurance?.company}
            </p>
            <p className="p-col-3 contact">
              {company?.insurance?.number}
            </p>
          </div>
        </div>
    
        <p className="col-1" style={{ fontSize: 12 , opacity: 0.58 }} >Modifié le {translateDate(company.updatedAt, 'fr')}</p> 
      </div>
    )
  };

  function renderShopCompany() {
    return (
      <div className="card">

        <div className="information-container">
          <p className="p-col-3">
            <span className="bold"><Translate id="company.social"/></span><br/>
            {company.name}
          </p>
          <p className="p-col-3">
            <span className="bold"><Translate id="company.acdlec"/></span><br/>
            {company.acdlec}
          </p>
          <p className="p-col-3">
            <span className="bold"><Translate id="company.central"/></span><br/>
            {company.centrale}
          </p>
          <p className="p-col-3">
            <span className="bold"><Translate id="company.city"/></span><br/>
            {company.location.city}
          </p>
          {mainUser?.profile &&
            <p className="p-col-3">
              <span className="bold"><Translate id="company.mainUser"/></span><br/>
              {mainUser.profile.firstName} {mainUser.profile.lastName}
            </p>
          }
          <div className="col-1">
          <span className="bold"><Translate id="company.activities"/></span><br/>
          <div className="information-container">
            <div className="col-1">
              {company.domainsCode.map((item ,i ) => <div key={i} className="list-item selected">{item.label} / {item.code}</div>)}
            </div>
          </div>
          </div>
        </div>
        <span style={{ fontSize: 12 , opacity: 0.58 }} >Modifié le {translateDate(company.updatedAt, 'fr')}</span> 
      </div>
    )
  }
  
  return (
    <>
      <div className="title">
        <h2><Translate id="company.title"/></h2>
        <Link to={"/"+ props.root + "-edit/" + company._id} className="btn-edit"><Translate id="btn.edit"/></Link>
        {props.root === "provider" && <button style={{ paddingLeft: 10 , paddingRight: 10  }} className="btn-edit" onClick={() => alertResetCompany()}>réinitialiser le fournisseur</button>}
      </div>
      {props.root === "provider"?
        renderProviderCompany()
        :
        renderShopCompany()
      }
    </>
  )
}
